import type { FlightPlan, Flight } from '@/types/flights';

export function calculateTotalCost(flights: Flight[]): number {
  return flights.reduce((total, flight) => total + flight.Rate.amount, 0);
}

export function calculatePriceDifference(selectedPlan: FlightPlan, alternatePlan: FlightPlan): number {
  const selectedCost = calculateTotalCost(selectedPlan.flights);
  const alternateCost = calculateTotalCost(alternatePlan.flights);
  return alternateCost - selectedCost;
}
